import { Component } from '@angular/core';

@Component({
  selector: 'fgb-feed-page',
  templateUrl: './feed-page.component.html',
  styleUrl: './feed-page.component.scss'
})
export class FeedPageComponent {

}
